import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BookOpen, Sparkles } from "lucide-react";

export function WelcomeModal() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!user?.id || user.status !== "approved") return;
    const key = `aktifokur_welcome_${user.id}`;
    if (!localStorage.getItem(key)) {
      const t = setTimeout(() => setOpen(true), 600);
      return () => clearTimeout(t);
    }
  }, [user?.id, user?.status]);

  const dismiss = () => {
    if (user?.id) localStorage.setItem(`aktifokur_welcome_${user.id}`, "1");
    setOpen(false);
  };
  const goProfile = () => { dismiss(); navigate("/profil"); };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent className="bg-surface max-w-md text-center p-8" data-testid="welcome-modal">
        <div className="w-16 h-16 mx-auto rounded-full bg-terra/10 border border-terra/20 flex items-center justify-center">
          <BookOpen className="text-terra" size={30} />
        </div>
        <h2 className="font-serif text-3xl text-ink mt-5">AktifOkur'a Hoş Geldin!</h2>
        <p className="text-sm text-ink-2 leading-relaxed mt-3">
          Düşüncenin, felsefenin ve nitelikli okumanın merkezine adım attın. Birlikte okuyacağımız,
          tartışacağımız ve zihinsel yolculuklara çıkacağımız harika bir topluluk seni bekliyor.
        </p>
        <p className="text-sm text-ink-2 leading-relaxed mt-3">
          Yolculuğuna başlamadan önce seni biraz tanıyalım! Profiline giderek geçmişte okuduğun
          kitapları ekleyebilir, kütüphaneni oluşturmaya ve ilk puanlarını kazanmaya başlayabilirsin.
        </p>
        <div className="flex flex-col sm:flex-row gap-2 mt-6">
          <Button onClick={goProfile} data-testid="welcome-go-profile"
            className="flex-1 bg-terra hover:bg-terra-hover text-white gap-1.5">
            <Sparkles size={15} /> Profilime Git ve Kitaplarımı Ekle
          </Button>
          <Button onClick={dismiss} data-testid="welcome-later" variant="outline" className="border-line">
            Daha Sonra
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
